export const PINNED = `pinned`
export const ENTRY = `key
date
type
text
image
thumbnailImage
pinned
platform
month
year
review
tags
reflection`
export const REFLECTION_OBJECT = `entryKey
question
questionResponse
note
updatedAt`
export const REFLECTION_OBJECT_KEYS = [
  "entryKey",
  "question",
  "questionResponse",
  "note",
  "updatedAt",
  "__typename",
]
export const YEARLY_REVIEW_FIELDS = `id
date
version
draft
lowlightsNotes
categoryQuestions
hightlightsQuestions
favorites
lowlightsQuestions
revisionQuestions
summaryQuestions
rankings
`
